import { useQueries } from "@tanstack/react-query";
import {
  client,
  type OoSEventBufferSchema,
} from "@augmodo/lebron-browser-client";

export const useEvents = (eventIds: string[] | undefined) => {
  const queries = useQueries({
    queries: (eventIds || []).map((eventId) => ({
      queryKey: ["oos-event", eventId],
      queryFn: async () => {
        const response = await client.get({
          url: `/v1/oos-event-buffer/${eventId}`,
        });

        if (response.error) {
          throw new Error(`Failed to fetch event: ${response.error}`);
        }

        return response.data as OoSEventBufferSchema;
      },
      enabled: !!eventId,
    })),
  });

  return {
    events: queries.map((q) => q.data),
    isLoading: queries.some((q) => q.isLoading),
    isError: queries.some((q) => q.isError),
    errors: queries.map((q) => q.error),
  };
};
